import { render, staticRenderFns } from "./Lecturer.vue?vue&type=template&id=64d8c2dd&"
import script from "./Lecturer.vue?vue&type=script&lang=js&"
export * from "./Lecturer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports